import { gql } from '@apollo/client';

/**
 * GraphQL queries are excluded from unit-test coverage by policy.
 * See `docs/conventions/` and `TESTING.md` for the ride-list page scope.
 */
export const SEARCH_LINES_BY_CODE = gql`
	query searchLinesByCode($lineCode: String!) {
		searchLinesByCode(lineCode: $lineCode) {
			id
			code
			title
		}
	}
`;
